import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-achievements.reducer';

export const UserAchievementsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userAchievementsEntity = useAppSelector(state => state.userAchievements.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userAchievementsDetailsHeading">
          <Translate contentKey="fivePlusApp.userAchievements.detail.title">UserAchievements</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userAchievementsEntity.id}</dd>
          <dt>
            <span id="fileName">
              <Translate contentKey="fivePlusApp.userAchievements.fileName">File Name</Translate>
            </span>
          </dt>
          <dd>{userAchievementsEntity.fileName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="fivePlusApp.userAchievements.status">Status</Translate>
            </span>
          </dt>
          <dd>{userAchievementsEntity.status}</dd>
          <dt>
            <span id="submittedDate">
              <Translate contentKey="fivePlusApp.userAchievements.submittedDate">Submitted Date</Translate>
            </span>
          </dt>
          <dd>
            {userAchievementsEntity.submittedDate ? (
              <TextFormat value={userAchievementsEntity.submittedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="originalFileName">
              <Translate contentKey="fivePlusApp.userAchievements.originalFileName">Original File Name</Translate>
            </span>
          </dt>
          <dd>{userAchievementsEntity.originalFileName}</dd>
          <dt>
            <span id="rejectionReason">
              <Translate contentKey="fivePlusApp.userAchievements.rejectionReason">Rejection Reason</Translate>
            </span>
          </dt>
          <dd>{userAchievementsEntity.rejectionReason}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fivePlusApp.userAchievements.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {userAchievementsEntity.createdDate ? (
              <TextFormat value={userAchievementsEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="externalLink">
              <Translate contentKey="fivePlusApp.userAchievements.externalLink">External Link</Translate>
            </span>
          </dt>
          <dd>{userAchievementsEntity.externalLink}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.userAchievements.user">User</Translate>
          </dt>
          <dd>{userAchievementsEntity.user ? userAchievementsEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.userAchievements.achievements">Achievements</Translate>
          </dt>
          <dd>{userAchievementsEntity.achievements ? userAchievementsEntity.achievements.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-achievements" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-achievements/${userAchievementsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserAchievementsDetail;
